(() => {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let lastFocus = null;
  let galleryIndex = 0;
  let paused = false;
  try { paused = localStorage.getItem('culloh-motion') === 'paused'; } catch (_) { /* Optional preference. */ }

  function syncMotion() {
    document.documentElement.dataset.motion = paused ? 'paused' : 'running';
    document.querySelectorAll('[data-motion-toggle]').forEach(button => {
      button.setAttribute('aria-pressed', String(paused));
      const isHero = button.classList.contains('motion-button');
      const label = paused ? (isHero ? 'Play motion' : 'Enable motion') : (isHero ? 'Pause motion' : 'Reduce motion');
      button.setAttribute('aria-label', label + ' for decorative images');
      const text = button.querySelector('[data-motion-label]');
      if (text) text.textContent = label;
    });
  }
  syncMotion();

  function openDialog(id, trigger) {
    const dialog = document.getElementById(id);
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    lastFocus = trigger || document.activeElement;
    if (!dialog.open) dialog.showModal();
    return true;
  }

  function showGallery(index) {
    const items = [...document.querySelectorAll('[data-gallery-index]')];
    if (!items.length) return;
    galleryIndex = (index + items.length) % items.length;
    const original = items[galleryIndex].querySelector('img');
    const photo = document.querySelector('[data-gallery-image]');
    const caption = document.querySelector('[data-gallery-caption]');
    if (original && photo) { photo.src = original.currentSrc || original.src; photo.alt = original.alt; }
    if (original && caption) caption.textContent = `${galleryIndex + 1} / ${items.length} — ${original.alt}`;
  }

  function goToChapter(index, focus = false) {
    const track = document.querySelector('[data-horizontal-track]');
    if (!track) return;
    const panels = [...track.querySelectorAll(':scope > [data-chapter]')];
    index = Math.max(0, Math.min(panels.length - 1, index));
    track.scrollTo({ left: index * track.clientWidth, behavior: reduced.matches ? 'instant' : 'smooth' });
    if (focus && panels[index]) {
      panels[index].setAttribute('tabindex', '-1');
      lastFocus = panels[index];
      panels[index].focus({ preventScroll: true });
    }
  }

  function initialiseTrack() {
    const track = document.querySelector('[data-horizontal-track]');
    if (!track || track.dataset.ready === 'true') return;
    track.dataset.ready = 'true';
    let lastWheel = 0;
    function syncTrack() {
      const panels = [...track.querySelectorAll(':scope > [data-chapter]')];
      const active = Math.max(0, Math.min(panels.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      track.dataset.panel = String(active);
      const count = document.querySelector('[data-chapter-current]');
      if (count) count.textContent = String(active + 1).padStart(2, '0');
      document.querySelectorAll('[data-chapter-go]').forEach(button => {
        if (Number(button.dataset.chapterGo) === active) button.setAttribute('aria-current', 'page');
        else button.removeAttribute('aria-current');
      });
      const prev = document.querySelector('[data-chapter-prev]');
      const next = document.querySelector('[data-chapter-next]');
      if (prev) prev.disabled = active === 0;
      if (next) next.disabled = active === panels.length - 1;
      const hats = track.querySelector('.landing-hats');
      if (hats) hats.style.setProperty('--travel', `${paused || reduced.matches ? 0 : Math.min(track.scrollLeft, track.clientWidth) * .24}px`);
    }
    track.addEventListener('scroll', syncTrack, { passive: true });
    track.addEventListener('wheel', event => {
      if (event.ctrlKey || Math.abs(event.deltaX) > Math.abs(event.deltaY) || Math.abs(event.deltaY) < 8) return;
      const panel = event.target.closest('[data-chapter]');
      if (panel && panel.scrollHeight > panel.clientHeight + 2 && ((event.deltaY > 0 && panel.scrollTop + panel.clientHeight < panel.scrollHeight - 3) || (event.deltaY < 0 && panel.scrollTop > 3))) return;
      event.preventDefault();
      if (Date.now() - lastWheel < 850) return;
      lastWheel = Date.now();
      goToChapter(Number(track.dataset.panel || 0) + Math.sign(event.deltaY));
    }, { passive: false });
    track.addEventListener('keydown', event => {
      if (event.target !== track) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        goToChapter(Number(track.dataset.panel || 0) + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    const resize = new ResizeObserver(() => {
      const index = Number(track.dataset.panel || 0);
      track.scrollTo({ left: index * track.clientWidth, behavior: 'instant' });
      syncTrack();
    });
    resize.observe(track);
    syncTrack();
    const hashPanel = [...track.querySelectorAll(':scope > [data-chapter]')].findIndex(panel => '#' + panel.id === location.hash);
    if (hashPanel >= 0) requestAnimationFrame(() => goToChapter(hashPanel));
  }
  initialiseTrack();
  document.addEventListener('shopify:section:load', initialiseTrack);

  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const motion = target.closest('[data-motion-toggle]');
    if (motion) {
      paused = !paused; syncMotion();
      try { localStorage.setItem('culloh-motion', paused ? 'paused' : 'running'); } catch (_) { /* Optional preference. */ }
      return;
    }
    const close = target.closest('[data-close-dialog]');
    if (close) { close.closest('dialog')?.close(); return; }
    const gallery = target.closest('[data-gallery-index]');
    if (gallery) { showGallery(Number(gallery.dataset.galleryIndex)); openDialog('LookbookPhoto', gallery); return; }
    if (target.closest('[data-gallery-prev]')) { showGallery(galleryIndex - 1); return; }
    if (target.closest('[data-gallery-next]')) { showGallery(galleryIndex + 1); return; }
    const opener = target.closest('[data-open-dialog]');
    if (opener && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      if (openDialog(opener.dataset.openDialog, opener)) event.preventDefault();
      return;
    }
    const thumb = target.closest('[data-photo-src]');
    if (thumb) {
      const detail = thumb.closest('[data-product-detail]');
      const img = detail?.querySelector('[data-product-image]');
      if (img) { img.removeAttribute('srcset'); img.src = thumb.dataset.photoSrc; img.alt = thumb.dataset.photoAlt || ''; }
      detail?.querySelectorAll('[data-photo-src]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
      return;
    }
    const track = document.querySelector('[data-horizontal-track]');
    if (!track) return;
    const chapter = target.closest('[data-chapter-go]');
    if (chapter) { goToChapter(Number(chapter.dataset.chapterGo), true); return; }
    if (target.closest('[data-chapter-prev]')) { goToChapter(Number(track.dataset.panel || 0) - 1, true); return; }
    if (target.closest('[data-chapter-next]')) { goToChapter(Number(track.dataset.panel || 0) + 1, true); return; }
    const anchor = target.closest('a[href]');
    if (!anchor || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(anchor.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash) return;
    const panels = [...track.querySelectorAll(':scope > [data-chapter]')];
    const index = panels.findIndex(panel => '#' + panel.id === url.hash);
    if (index >= 0) { event.preventDefault(); anchor.closest('dialog')?.close(); goToChapter(index, true); }
  });

  document.addEventListener('change', event => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches('[data-variant-select]')) return;
    const detail = select.closest('[data-product-detail]');
    const option = select.selectedOptions[0];
    if (!detail || !option) return;
    const available = option.dataset.available === 'true';
    const price = detail.querySelector('[data-product-price]');
    const status = detail.querySelector('[data-product-availability]');
    const button = detail.querySelector('[data-product-submit]');
    if (price) price.textContent = option.dataset.price || '';
    if (status) status.textContent = available ? 'Available to order' : 'Sold out';
    if (button) { button.disabled = !available; button.textContent = available ? 'Add to bag' : 'Sold out'; }
    const image = detail.querySelector('[data-product-image]');
    if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; image.alt = option.dataset.imageAlt || ''; }
    if (document.body.classList.contains('template-product')) {
      const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
    }
  });

  document.addEventListener('close', event => {
    if (event.target instanceof HTMLDialogElement && lastFocus?.isConnected) lastFocus.focus();
  }, true);
  document.addEventListener('click', event => {
    if (!(event.target instanceof HTMLDialogElement)) return;
    const box = event.target.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
  });
})();
